import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";
import {findDoiInString} from "../utils/doi.js";

export const PN_PROQUEST_DETAILS_URL_REQUEST = "PN_PROQUEST_DETAILS_URL_REQUEST";
export const PN_PROQUEST_DETAILS_URL_RESPONSE = "PN_PROQUEST_DETAILS_URL_RESPONSE";

class ProQuest extends WebsiteBehaviors {
	identifier() {
		return "ProQuest";
	}

	// @ts-expect-error FIXME
	static test(location) {
		// Example: https://www.proquest.com/docview/2699193286/2C651D276115449APQ/2?accountid=14707
		return location.href.match(/^https?:\/\/(www|search)\.proquest\.com\/(.*\/)?(docview|pagepdf|results|publicationissue|browseterms|browsetitles|browseresults|myresearch\/(figtables|documents))/g);
	}

	getDetailsUrl() {
		// Fetch the "Details" or "Abstract/Details" page, which contains information for building a citation
		const detailsLink = (document.getElementById("addFlashPageParameterformat_abstract")
			?? document.getElementById("addFlashPageParameterformat_citation"))
			?? document.getElementById("link_prefix_addFlashPageParameterformat_citation");

		// @ts-expect-error FIXME
		return detailsLink ? detailsLink.href : undefined;
	}

	async topFrameHandler() {
		// For ProQuest PDF pages, the top frame needs to get the details page
		// url for the PDF frame. See ProQuestPdf.js
		window.addEventListener("message", (evt) => {
			if (evt.data.type === PN_PROQUEST_DETAILS_URL_REQUEST) {
				// @ts-expect-error FIXME
				evt.source.postMessage({
					type: PN_PROQUEST_DETAILS_URL_RESPONSE,
					url:  this.getDetailsUrl()
				// @ts-expect-error FIXME
				}, "*");
			}
		});

		return null;
	}

	async generateStructuredCitation() {
		return generateProQuestCitation(this.getDetailsUrl());
	}
}

export default ProQuest;

// Export it so that ProQuestPdf can use it too
// @ts-expect-error FIXME
export const generateProQuestCitation = async (url) => {
	let detailsUrl = url;
	let detailsPage;

	if (!url) {
		// Url wasn't found in the page, make a guess for what it might be
		// Posslbe url examples:
		// https://www.proquest.com/docview/2138580136/citation/580FF1652B8747DAPQ/1?accountid=14707
		// https://www.proquest.com/docview/2712366712/abstract/14D4AFAE9E2641F0PQ/2?accountid=14707
		const currentUrl = location.href;

		let replacementRegex;
		try {
			replacementRegex = new RegExp("(?<=(docview|pagepdf|results|publicationissue|browseterms|browsetitles|browseresults|myresearch/(figtables|documents))/\\w+)/", "g");
		} catch (e) {
			// 2023-01-27: Safari doesn't support this yet: https://caniuse.com/js-regexp-lookbehind
			return null;
		}

		// Try them one by one
		try {
			// Ex:
			// https://www.proquest.com/docview/2138580136/580FF1652B8747DAPQ/1?accountid=14707&tocViewMode=tocViewModeSearch
			detailsUrl = currentUrl.replace(replacementRegex, "/citation/");
			detailsPage = await fetch(detailsUrl, {"method": "GET"});
		} catch (e) {
			// Ex:
			// https://www.proquest.com/docview/2712366712/abstract/14D4AFAE9E2641F0PQ/2?accountid=14707
			detailsUrl = currentUrl.replace(replacementRegex, "/abstract/");
			detailsPage = await fetch(detailsUrl, {"method": "GET"});
		}
	} else
		detailsPage = await fetch(detailsUrl, {"method": "GET"});

	const detailsPageHtml = await detailsPage.text();
	const parser = new DOMParser();
	const detailsDOM = parser.parseFromString(detailsPageHtml, "text/html");

	// Get citation info rows from details page DOM
	const rows = Array.from(detailsDOM.querySelectorAll(".display_record_indexing_row"));

	const csl = {}; // CSL format citation data
	const types = [];

	let nameElem, valueElem, name, value;
	for (const row of rows) {
		// Use a try catch block, so that the whole citation doesn't fail if
		// some specific values fail
		try {
			nameElem = row.querySelector(".display_record_indexing_fieldname");
			valueElem = row.querySelector(".display_record_indexing_data");

			if (!nameElem || !valueElem)
				continue;

			// @ts-expect-error FIXME
			name = nameElem.textContent.trim();
			// Assume the value is a simple string by default. If it's not,
			// it'll be reformatted in a bit
			// @ts-expect-error FIXME
			value = valueElem.textContent.trim();

			switch (name) {
				case "Title":
					// @ts-expect-error FIXME
					csl.title = value;
					break;

				case "Publication title": {
					// It seems like the publication title is always (or is it?)
					// a link, followed by the publication location, so let's
					// ignore the location
					const pubTitleElem = valueElem.querySelector("a.lateralSearch");
					// @ts-expect-error FIXME
					csl["container-title"] = pubTitleElem ? pubTitleElem.textContent : value;
					break;
				}

				case "Author": {
					// Create an array of author names
					let authors = Array.from(valueElem.querySelectorAll("a.lateralSearch"));
					// @ts-expect-error FIXME
					authors = authors.map(link => link.textContent);

					// @ts-expect-error FIXME
					csl.author = Citation.getCSLnames(authors);
					break;
				}

				case "First page":
					// @ts-expect-error FIXME
					csl["page-first"] = value;
					break;

				case "Pages":
					// @ts-expect-error FIXME
					csl.page = value;
					break;

				// TODO: prefer publication date over publication year (more specific)
				case "Publication year":
				case "Publication date":
					// @ts-expect-error FIXME
					csl.issued = Citation.getCSLdate(value);
					break;

				case "Section":
					// @ts-expect-error FIXME
					csl.section = value;
					break;

				case "Publisher":
					// @ts-expect-error FIXME
					csl.publisher = value;
					break;

				case "Country of publication":
				case "Place of publication":
					// @ts-expect-error FIXME
					csl["publisher-place"] = value;
					break;

				case "ISSN":
					// @ts-expect-error FIXME
					csl.ISSN = value;
					break;

				case "Language of publication":
					// TODO:
					// Should be entered as an ISO 639-1 two-letter language code (e.g. “en”, “zh”), optionally with a two-letter locale code (e.g. “de-DE”, “de-AT”)
					// @ts-expect-error FIXME
					csl.language = value;
					break;

				// TODO: Prefer Document type over Source type (more specific)
				case "Source type":
				case "Document type":
					types.push(value);
					break;

				case "DOI":
					// Try getting the entire citation using the DOI
					try {
						const doi = findDoiInString(value);
						if (doi) {
							const citationFromDoi = await Citation.fromDOI(doi);
							if (citationFromDoi?.csl?.type)
								return citationFromDoi;
						}
					} catch (e) {}

					// @ts-expect-error FIXME
					csl.DOI = value;
					break;

				case "ISBN":
					// @ts-expect-error FIXME
					csl.ISBN = value;
					break;

				case "Document URL":
					// @ts-expect-error FIXME
					csl.URL = value;
					break;

				case "Volume":
					// @ts-expect-error FIXME
					csl.volume = value;
					break;

				case "Issue":
					// @ts-expect-error FIXME
					csl.issue = value;
					break;

				case "Location":
					// @ts-expect-error FIXME
					csl["event-place"] = value;
					break;

				// Ignore these for now
				case "Subject":
				case "Business indexing term":
				case "Company / organization":
				case "Classification":
				case "Publication subject":
				case "Copyright":
				case "Last updated":
				case "Database":
				default:
					// Unknown/unhandled field name
			}
		} catch (e) {}
	}

	// @ts-expect-error FIXME
	csl.type = Citation.getCSLtype(types, "article-journal");

	return Citation.fromCSL(csl);
};
